"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractSheetInfo = extractSheetInfo;
const Util_1 = require("../../Util");
function extractSheetInfo(node) {
    let start = [0, 0];
    let size = [0, 0];
    let sheetname;
    let sheetfile;
    let uuid;
    node.nodes.forEach((n) => {
        switch (n.name) {
            case 'at': {
                start = [parseFloat(n.values[0]), parseFloat(n.values[1])];
                break;
            }
            case 'size': {
                size = [parseFloat(n.values[0]), parseFloat(n.values[1])];
                break;
            }
            case 'uuid': {
                uuid = (0, Util_1.removeQuotes)(n.values[0]);
                break;
            }
            case 'property': {
                switch (n.values[0].toLowerCase()) {
                    case '"sheetname"':
                        sheetname = (0, Util_1.removeQuotes)(n.values[1]);
                        break;
                    case '"sheetfile"':
                        sheetfile = (0, Util_1.removeQuotes)(n.values[1]);
                        break;
                }
                break;
            }
        }
    });
    return {
        start,
        size,
        sheetname,
        sheetfile,
        uuid,
    };
}
//# sourceMappingURL=v6ExtractSheetInfo.js.map